import styled from "styled-components";

export const MobileControllerPrizeWrapper = styled.div<{ $hasBottomBar?: boolean }>`
  padding: 58px 24px ${(props) => (props.$hasBottomBar ? "100px" : "30px")};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  font-family: Pretendard;
`;

export const MobileControllerPrizeInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .box {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #eff6ff;
    padding: 12px;
    gap: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 16.8px */
    color: #1c398e;

    &.red {
      background: #fff3e0;
      flex-direction: row;
      color: #f00;
      align-items: flex-start;
      gap: 8px;
      font-weight: 500;
      line-height: 100%; /* 14px */
    }

    > .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .name {
        display: flex;
        align-items: center;
        gap: 2px;
        color: #1447e6;
        font-weight: 500;
        line-height: 100%; /* 14px */
      }

      > div {
        display: flex;
        gap: 8px;
        align-items: flex-start;
      }
    }
  }
`;

export const MobileControllerPrizeInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;

  > input {
    text-align: center;
    width: 70px;
    border-radius: 10px;
    border: 1px solid #b7b7b7;
    outline: none;
    padding: 8px 12px;
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    box-sizing: border-box;
    font-weight: 500;
    line-height: 100%; /* 14px */
  }
`;

export const MobileControllerPrizeBottomWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 24px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  gap: 12px;
  background: #fff;

  > .button {
    flex: 1;
    display: flex;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    background: var(--Purple-300, #6436e7);
    color: #fff;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &.red {
      background: #f00;
    }
  }
`;

export const MobileControllerPrizeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MobileControllerPrizeItemWrapper = styled.div<{
  $isPayment: boolean;
}>`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  border-radius: 8px;
  background: ${(props) => (props.$isPayment ? "#D1C3F8" : "#fff")};
  border: 1px solid ${(props) => (props.$isPayment ? "#6436E7" : "#B7B7B7")};
`;

export const MobileControllerPrizeItemSummary = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  color: #121212;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 14px */
`;

export const MobileControllerPrizeItemSummaryLeft = styled.div<{
  $isPayment: boolean;
}>`
  display: flex;
  gap: 10px;
  align-items: center;

  > .rank {
    display: flex;
    width: 50px;
    height: 24px;
    padding: 2px 14px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    background: ${(props) => (props.$isPayment ? "#6436E7" : "#101828")};
    color: #fff;
    border-radius: 4px;
  }

  > .name {
    display: flex;
    gap: 2px;
    align-items: center;
    color: ${(props) => (props.$isPayment ? "#6436E7" : "#808080")};
  }
`;

export const MobileControllerPrizeItemSummaryRight = styled.div<{
  $isOpen: boolean;
}>`
  display: flex;
  gap: 10px;
  align-items: center;

  > img {
    transform: rotate(${(props) => (props.$isOpen ? "180deg" : "0deg")});
    transition: transform 0.3s ease;
  }
`;

export const MobileControllerPrizeItemDetail = styled.div<{ $isOpen: boolean }>`
  border-top: ${(props) => (props.$isOpen ? "1px solid #e5e7eb" : "none")};
  max-height: ${(props) => (props.$isOpen ? "1000px" : "0px")};
  margin-top: ${(props) => (props.$isOpen ? "16px" : "0px")};
  padding: ${(props) => (props.$isOpen ? "12px 0" : "0px")};
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  overflow-y: hidden;
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
  transition:
    max-height ${(props) => (props.$isOpen ? "0.25s" : "0.15s")}
      cubic-bezier(0.4, 0, 0.2, 1),
    margin-top ${(props) => (props.$isOpen ? "0.25s" : "0.15s")}
      cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const MobileControllerPrizeItemDetailRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MobileControllerPrizeItemDetailRow = styled.div<{
  $isPayment: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Pretendard;

  > .name {
    color: #121212;
    font-size: 12px;
    font-weight: 500;
    line-height: 100%; /* 12px */
  }

  > .box {
    position: relative;
    padding: 8px 12px;
    gap: 10px;
    align-self: stretch;
    border-radius: 10px;
    border: 1px solid #b7b7b7;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    color: ${(props) => (props.$isPayment ? "#808080" : "#121212")};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  > .nickname {
    position: relative;
    padding: 8px 12px;
    gap: 10px;
    align-self: stretch;
    border-radius: 10px;
    background: #121212;
    width: 100%;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > input {
    border-radius: 10px;
    border: 1px solid #b7b7b7;
    background: #fff;
    outline: none;
    padding: 8px 12px;
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    width: 100%;
    box-sizing: border-box;
  }

  > input:disabled {
    color: #808080;
  }
`;

export const MobileControllerPrizeItemDetailRowCount = styled.div<{
  $isPayment: boolean;
}>`
  display: flex;
  gap: 5px;
  align-items: center;

  > .button {
    display: flex;
    width: 36px;
    height: 36px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #b7b7b7;
    background: #fff;
    cursor: pointer;
    box-sizing: border-box;
  }

  > .count {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid #b7b7b7;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    color: ${(props) => (props.$isPayment ? "#808080" : "#121212")};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
  }
`;

export const MobileControllerPrizeItemButton = styled.div<{
  $isPayment: boolean;
}>`
  display: flex;
  width: 100%;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  color: #fff;
  background: ${({ $isPayment }) =>
    $isPayment ? "#f00" : "var(--Purple-300, #6436E7)"};
`;
